import { render, staticRenderFns } from "./MyLOGOffer.vue?vue&type=template&id=2d86c83a"
import script from "./MyLOGOffer.vue?vue&type=script&lang=js"
export * from "./MyLOGOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports